(ns decimal.extern.decimaljs
  (:require ["decimal.js" :as decimal-js]))
(js/goog.exportSymbol "Decimal.noConflict" (fn [] decimal-js))

;; https://github.com/funcool/decimal/issues/7#issuecomment-448576845
